import { Component, OnInit } from '@angular/core';
import { Usuario } from './usuarios.model';
import { Router } from '@angular/router';

// services
import { EventService } from 'src/app/core/service/event.service';
import { UsuarioService } from './usuarios.service';


// constants
import { EventType } from 'src/app/core/constants/events';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-new-usuario',
  templateUrl: './new-usuario.component.html',
  styleUrls: ['./new-usuario.component.scss']
})
export class NewUsuarioComponent implements OnInit {

  constructor(
    private eventService: EventService,
    private usuarioService: UsuarioService,
    private router: Router) { }

    model = {
      nombre: '',
      apellidos: '',
      email: '',
      telefono: '',
      nivel_acceso: 'ADMIN',
    }

  ngOnInit(): void {
    this.eventService.broadcast(EventType.CHANGE_PAGE_TITLE,
      {
        title: 'Nuevo administrador',
        breadCrumbItems: [{ label: 'Usuarios', path: '.' }, { label: 'Nuevo administrador', path: '.', active: true }]
      }
    );
  }

  onSubmit(form: NgForm) {

    let nivelAcceso = form.value.nivel_acceso;
    let esRepresentante = false;

    // Si el nivel de acceso es REPRESENTANTE, el nivel_acceso debe ser USUARIO y es_representante = 1
    if (nivelAcceso === 'REPRESENTANTE') {
        nivelAcceso = 'USUARIO';
        esRepresentante = true;
    }

    const usuario: Usuario = {
      nombre: form.value.nombre,
      apellidos: form.value.apellidos,
      email: form.value.email,
      telefono: form.value.telefono,
      validado: false,
      activo: true,
      nivel_acceso: nivelAcceso, // Ajusta el valor de nivel_acceso
      es_arbitro: false,
      es_representante: esRepresentante // Añade esta línea
    };


    
    this.usuarioService.newUsuario(usuario)
      .subscribe(res => {
        this.router.navigate(['/usuarios']);
      })
    
  }

}
